import { useQuery } from "@tanstack/react-query";
import { getQueryFn } from "@/lib/queryClient";
import {
  DEFAULT_TIMELINE_CAPABILITIES,
  type TimelineCapabilities,
} from "@scroll/shared-types";

export { DEFAULT_TIMELINE_CAPABILITIES, type TimelineCapabilities };

export function useTimelineCapabilities(): TimelineCapabilities {
  const { data } = useQuery<TimelineCapabilities>({
    queryKey: ["/api/timeline-capabilities"],
    queryFn: getQueryFn({ on401: "returnNull" }),
    staleTime: 30 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    refetchOnMount: "always",
    refetchOnReconnect: "always",
  });

  return data ?? DEFAULT_TIMELINE_CAPABILITIES;
}
